import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import _ from "lodash";
import Time from "react-time-format";

class FormPrintArz extends React.Component {
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const { KD_all3arzKala, KD_code, KD_name, KD_draw } = value;
            const wakelRaport = KD_all3arzKala.map((user, i) => {
              if (user.table.length != 0) {
                let ten = _.multiply(_.last(user.table).numberOfCarton, 0.1);
                return (
                  <>
                    <tr
                      key={i}
                      className="f4"
                      style={{
                        color: `${Number(user.rasidKarton) <= ten ? "red" : ""}`
                      }}
                    >
                      <td className="fk" style={{ border: "2px solid black" }}>
                        {user.rasidKarton}
                      </td>
                      <td className="fk" style={{ border: "2px solid black" }}>
                        {Number(
                          _.subtract(
                            _.last(user.table).numberOfCarton
                              ? _.last(user.table).numberOfCarton
                              : 0,
                            user.rasidKarton
                          )
                        ).toFixed(2)}
                      </td>
                      <td className="fk" style={{ border: "2px solid black" }}>
                        {_.last(user.table).numberOfCarton}
                      </td>
                      <td className="fk" style={{ border: "2px solid black" }}>
                        {user.priceOneRRR}
                      </td>
                      <td className="fk" style={{ border: "2px solid black" }}>
                        {user.zhmarayDwkan}
                      </td>
                      <td className="fk" style={{ border: "2px solid black" }}>
                        {user.nameofproduct}
                      </td>
                      <td className="fk" style={{ border: "2px solid black" }}>
                        {" "}
                        <Time
                          value={_.last(user.table).date}
                          format="YYYY-MM-DD"
                          style={{ color: "black" }}
                        />
                      </td>
                      <td className="fk" style={{ border: "2px solid black" }}>
                        {user.code}
                      </td>
                    </tr>
                  </>
                );
              }
            });

            return (
              <table id="example" className="table table-striped  text-right ">
                <thead>
                  <tr className="text-black f4">
                    <th style={{ border: "2px solid black" }}>ماوە</th>
                    <th style={{ border: "2px solid black" }}>فرۆشتن</th>
                    <th style={{ border: "2px solid black" }}>کڕین</th>
                    <th style={{ border: "2px solid black" }}>نرخی دنک</th>
                    <th style={{ border: "2px solid black" }}>ژ.دووکان</th>
                    <th style={{ border: "2px solid black" }}>ناوەی کاڵا</th>
                    <th style={{ border: "2px solid black" }}>بەروار</th>
                    <th style={{ border: "2px solid black" }}>کۆد</th>
                  </tr>
                </thead>
                <tbody>{wakelRaport}</tbody>
              </table>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}
export default FormPrintArz;
